import React from 'react';
import PropTypes from 'prop-types';
import SearchInput from '../../common/components/_SearchBox';
import DropdownItem from '../../common/components/_DropdownItem';
import DateFilterDropdown from '../../common/components/_DateFilterDropdown';

function staffProfilesFilter({ search, filters, settings }) {

    {/* 
    let data = d => {
        return d.children.map(c => ({ checked: (search.categories && search.categories.toString().split(',').includes(c.key) ? true : false ), label: c.name, value: c.key, children: c.children.map(ch => ({ label:ch.name, value: ch.key})) }));
    };

    const onChange = (currentNode ) => {
        addFilter(search, 'categories', currentNode.value, currentNode.checked);
    };

    */}

	return (
        <div className="filter-bar">
            <div className="filter__text">
                Filter by
            </div>
            <SearchInput search={search} settings={settings}/>
            {/* {filters && filters.taxonomyFilters && <DropdownItem search={search} title='Sponsors' options={filters.taxonomyFilters.sponsors} name='sponsors' istaxonomy={true} />}
            {filters && filters.taxonomyFilters && <DropdownItem search={search} title='University' options={filters.taxonomyFilters.university} name='university' istaxonomy={true} />}
            <DateFilterDropdown search={search} isYear={true} settings={settings} /> */}
        </div>
	);
}

staffProfilesFilter.propTypes = {
    entries: PropTypes.object,
    search: PropTypes.object,
    filters: PropTypes.object,
    settings: PropTypes.object,
};

export default staffProfilesFilter;
